import { useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Button from "core/buttons/button/Button";
import { DELIVERY_NOTE_SAVED_LIST_ACTIONS } from "constants/forms";
import DeliveryNoteDocumentPreview from "./DeliveryNoteDocumentPreview";
import DeliveryNotePreviewModalShell from "./DeliveryNotePreviewModalShell";
import useDeliveryNoteDocument from "./useDeliveryNoteDocument";
import useDeliveryNotePdfExport from "./useDeliveryNotePdfExport";

const DeliveryNoteSavedNoteModal = ({ note, onClose }) => {
  const { template, snapshot, resolveImage, documentNote, isReady } =
    useDeliveryNoteDocument(note);
  const { isExporting, exportRef, exportPdf } = useDeliveryNotePdfExport();

  const closeModal = useCallback(() => {
    if (!isExporting) onClose();
  }, [isExporting, onClose]);

  return (
    <DeliveryNotePreviewModalShell
      id="delivery-note-saved-note-preview-modal"
      title={note.number}
      onClose={closeModal}
      actions={
        <>
          <Button
            type="button"
            className="btn-small btn-outline"
            onClick={closeModal}
            disabled={isExporting}
            id="delivery-note-saved-note-preview-close"
          >
            <FormattedMessage {...DELIVERY_NOTE_SAVED_LIST_ACTIONS.close} />
          </Button>
          <Button
            type="button"
            color="btn-small gray-700"
            onClick={() => exportPdf({ template, number: note.number })}
            disabled={!isReady || isExporting}
            id="delivery-note-saved-note-preview-download"
          >
            <FormattedMessage
              {...DELIVERY_NOTE_SAVED_LIST_ACTIONS.previewDownload}
            />
          </Button>
        </>
      }
    >
      <DeliveryNoteDocumentPreview
        snapshot={snapshot}
        resolveImage={resolveImage}
        note={documentNote}
        isExporting={isExporting}
        exportRef={exportRef}
        showTitle={false}
      />
    </DeliveryNotePreviewModalShell>
  );
};

DeliveryNoteSavedNoteModal.propTypes = {
  note: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeliveryNoteSavedNoteModal;
